import { cn } from "@/lib/utils";
import { ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

export interface BreadcrumbItem {
  label: string;
  to?: string;
}

export const Breadcrumbs = ({ items, className }: { items: readonly BreadcrumbItem[]; className?: string }) => (
  <nav aria-label="Breadcrumb" className={cn("flex items-center gap-1 text-sm", className)}>
    {items.map((item, index) => {
      const isLast = index === items.length - 1;
      return (
        <span key={`${item.label}-${index}`} className="flex items-center gap-1">
          {item.to && !isLast ? (
            <Link to={item.to} className="text-muted-foreground hover:text-foreground">
              {item.label}
            </Link>
          ) : (
            <span className={isLast ? "font-medium text-foreground" : "text-muted-foreground"}>
              {item.label}
            </span>
          )}
          {isLast ? null : <ChevronRight className="size-3.5 text-muted-foreground" aria-hidden />}
        </span>
      );
    })}
  </nav>
);
